import { ABP, eLayoutType } from '@abp/ng.core';

export const GERENCIAMENTO_VIAGEM_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/gerenciamento-viagens',
    iconClass: 'fas fa-route',
    name: '::Menu:GerenciamentoViagens',
    layout: eLayoutType.application,
    order: 4,
    requiredPolicy: 'cargo_fleet.GerenciamentoViagens',
  },
];
